import EmailVerification from './EmailVerification'
import LogoutButton from './LogoutButton'
import PasswordReset from './PasswordReset'
import Profile from './Profile'
import Register from './Register'
import RegisterShadow from './RegisterShadow'
import UnsubscribeButton from './UnsubscribeButton'

Vue.component(EmailVerification.name, EmailVerification)
Vue.component(LogoutButton.name, LogoutButton)
Vue.component(PasswordReset.name, PasswordReset)
Vue.component(Profile.name, Profile)
Vue.component(Register.name, Register)
Vue.component(RegisterShadow.name, RegisterShadow)
Vue.component(UnsubscribeButton.name, UnsubscribeButton)

import './user-input'

export default {EmailVerification, LogoutButton, PasswordReset, Profile, Register, RegisterShadow, UnsubscribeButton}
